import axios from 'axios'

import { ConfigInterface } from '../Interfaces/ConfigsInterface'
import { versionInfo } from '../Other/Translation'

export const getConfigs = async () => {
  const endpoint = window?.initialConfiguration?.endpoints?.translations
  return (await axios.get<ConfigInterface>(`${endpoint}/config.json?_=${(await versionInfo).data.lastUpdated}`)).data
}
